import React, { ComponentProps } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { cn } from '../lib/utils';
import { Badge as UIBadge } from '../ui/badge';

export type BadgeProps = ComponentProps<typeof UIBadge> & {
    onRemove?: () => void;
    isRemovable?: boolean;
    width?: string;
};

const Badge: React.FC<BadgeProps> = ({
    className,
    children,
    onRemove,
    isRemovable = false,
    width = 'w-auto',
    variant = 'secondary',
    ...rest
}) => {
    return (
        <UIBadge
            variant={variant}
            className={cn(
                'bg-[#404040]/20 border-0 rounded-lg px-2 py-1.5 text-xs font-medium transition-colors cursor-pointer text-neutral-700',
                'max-w-[200px]',
                width,
                'flex items-center justify-between gap-2',
                className
            )}
            {...rest}
        >
            {isRemovable && onRemove && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    className="flex-shrink-0 hover:opacity-100 transition-opacity opacity-60"
                    aria-label="Remove"
                >
                    <FontAwesomeIcon
                        icon="fa-regular fa-xmark"
                        className="w-3 h-3"
                    />
                </button>
            )}
            <span className="flex-1 truncate text-left">{children}</span>
        </UIBadge>
    );
};

Badge.displayName = 'Badge';

export default Badge;

